import { Container } from "reactstrap";
import styles from './styles.module.scss';

export const Content = ({
  className,
  content,
  fullWidth,
  paddingTop = "pt-0",
  paddingBottom = "pb-5",
}) => {

  return (
    <section className={`${styles.root} ${className} ${paddingTop} ${paddingBottom} ${fullWidth ? styles.fullWidth : ''}`}>
      <Container fluid={fullWidth} className={fullWidth ? 'px-0' : ''}>
        <div className="mainContent" dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </section>
  );

}

export default Content;
